import {createContext, useState} from "react";


const MenuContext = createContext(false);

const MenuContextProvider = ({children}) => {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
      setMenuOpen(!menuOpen);
    };

    return (
      <MenuContext.Provider value={{menuOpen, toggleMenu}}>
        {children}
      </MenuContext.Provider>
    );
};

export {MenuContext, MenuContextProvider};